// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cross-domain-auth__iframe[data-v-366948a1]{width:0;height:0;visibility:hidden;position:absolute;right:-5000px}", ""]);
// Exports
module.exports = exports;
